var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useState } from "react";
import Onvo from "@onvo-ai/js";
import { jwtDecode } from "jwt-decode";
import "@onvo-ai/chartjs-chart-map/dist/style.css";
import { LoadScript } from '@react-google-maps/api';
const Context = createContext({
    backend: undefined,
    team: undefined,
    adminMode: false,
    account: undefined,
    embedUser: undefined,
    containerRef: null,
    setContainerRef: () => { },
});
export const Wrapper = ({ token, children, baseUrl = "https://dashboard.onvo.ai", adminMode, googleMapsApiKey }) => {
    const [team, setTeam] = useState();
    const [account, setAccount] = useState();
    const [embedUser, setEmbedUser] = useState();
    const [backend, setBackend] = useState(undefined);
    const [containerRef, setContainerRef] = useState(null);
    useEffect(() => {
        if (!baseUrl || baseUrl.trim() === "")
            return;
        if (!token || token.trim() === "")
            return;
        // Initialize Onvo backend with token and base URL
        let back = new Onvo(token, {
            endpoint: baseUrl,
        });
        setBackend(back);
    }, [token, baseUrl, adminMode]);
    const getSubscription = (teamId) => __awaiter(void 0, void 0, void 0, function* () {
        if (!backend)
            return;
        backend.teams.get(teamId).then(setTeam);
    });
    useEffect(() => {
        if (token && token !== "" && backend) {
            let decoded = jwtDecode(token);
            if (decoded.app_metadata.team) {
                backend.accounts.get(decoded.sub).then(setAccount);
            }
            else if (decoded.app_metadata.parent_team) {
                backend.embed_users.get(decoded.sub).then(setEmbedUser);
            }
            getSubscription(decoded.app_metadata.team || decoded.app_metadata.parent_team);
        }
    }, [token, backend]);
    return (React.createElement(Context.Provider, { value: {
            backend,
            team,
            adminMode: adminMode || false,
            account,
            embedUser,
            containerRef,
            setContainerRef,
        } },
        React.createElement(LoadScript, { googleMapsApiKey: googleMapsApiKey || "" }, children)));
};
export const useBackend = () => useContext(Context);
//# sourceMappingURL=Wrapper.js.map